import React, { useState, useEffect } from "react";
import { postReview } from "../../../../services/reviewsService";
import { getBusinessReviews } from "../../../../services/reviewsService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../context/AuthContext";
import StarRating from "../../../../utils/StarRating";
import { getImage } from "../../../../utils/cloudinarySizing";

const MyReviews = ({ businessId }) => {
    const { userId } = useAuth(); // Get the logged-in user's ID
    const [reviews, setReviews] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [newReview, setNewReview] = useState({ stars: 0, text: "" });
    const navigate = useNavigate();

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const data = await getBusinessReviews(businessId);
                setReviews(data.reviews);
            } catch (err) {
                console.log(err);
                setReviews([]);
            }
        };

        fetchReviews();
    }, [businessId]);

    const handleAddReview = () => {
        setShowForm((prevShowForm) => !prevShowForm);
    };

    const handleSubmitReview = async (e) => {
        e.preventDefault();
        if (newReview.stars > 0 && newReview.text.trim()) {
            const reviewData = {
                type: "business",
                id: businessId,
                rating: newReview.stars,
                comment: newReview.text,
            };

            try {
                const response = await postReview(reviewData);

                if (response.data) {
                    setReviews([response.data, ...reviews]);
                    setNewReview({ stars: 0, text: "" });
                    setShowForm(false);
                    alert("Successfully posted review");
                } else {
                    alert("Failed to post review. Please try again.");
                }
            } catch (error) {
                console.error("Error submitting review:", error);
                alert("An error occurred while submitting your review.");
            }
        } else {
            alert("Please fill out all fields before submitting!");
        }
    };

    if (reviews === null) return null;

    return (
        <div className="reviews-container">
            <p
                style={{
                    color: "var(--text)",
                    textAlign: reviews.length === 0 ? "center" : "right",
                }}
                className="own-reviews"
            >
                {reviews.length === 0
                    ? "No reviews"
                    : `${reviews.length} ${reviews.length === 1 ? "Review" : "Reviews"}`}
            </p>

            {showForm && (
                <form onSubmit={handleSubmitReview} className="add-review-form">
                    <label>
                        <StarRating
                            onRate={(rating) =>
                                setNewReview({ ...newReview, stars: rating })
                            }
                        />
                    </label>
                    <label>
                        Review:
                        <textarea
                            value={newReview.text}
                            onChange={(e) =>
                                setNewReview({ ...newReview, text: e.target.value })
                            }
                            placeholder="Write your review here..."
                        />
                    </label>
                    <button type="submit">Submit Review</button>
                </form>
            )}

            <div className="review-container">
                {reviews.map((review, index) => (
                    <div key={index} className="review-box">
                        <div className="review-content">
                            <div className="star-rating">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <i
                                        key={star}
                                        className={`fa-star ${review.rating >= star ? "fas highlighted" : "fas"}`}
                                    ></i>
                                ))}
                            </div>
                            <p className="review-text">"{review.comment}"</p>
                            <div className="review-user-info">
                                <p className="review-date">
                                    {new Date(review.created_at).toLocaleString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true
                                    })}
                                </p>

                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <img
                                        onClick={() => navigate(`/profile/${review.user.id}`)}
                                        src={getImage(review.user?.profile_image, "avatar_xsm") || '/servspace-default-40x40.png'}
                                        alt={review.user.name}
                                        className="review-user-image"
                                        onError={(e) => {
                                            e.currentTarget.onerror = null; // prevents infinite loop if fallback also fails
                                            e.currentTarget.src = '/servspace-default-40x40.png';
                                        }}
                                    />
                                    <p
                                        className="customer-name"
                                        onClick={() => navigate(`/profile/${review.user.id}`)}
                                    >
                                        {review.user.name}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MyReviews;